import styled from 'styled-components';

export const StyledAddressInfo = styled.div`
  .radio-controls-list {
    label {
      width: fit-content;
    }
  }
`;
